import React from 'react';
import { images } from '../data/site';
export function StorySection() {
  return <section id="maison" className="w-full bg-forest-800 py-24 lg:py-36" data-id="element-107" data-mp="h0xzibdlhpjc">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-12 lg:gap-10 lg:px-10" data-id="element-108" data-mp="gyv0x2ydmo30">
        <div className="lg:col-span-7" data-id="element-109" data-mp="7zzv3rz8vg08">
          <h2 className="font-serif text-4xl font-light leading-[1.1] text-cream-50 md:text-6xl" data-id="element-110" data-mp="8117q0vwsak2">
            Une ancienne maison de pierre et de brique, devenue le repaire des gourmands de{' '}
            <em className="text-ember-400" data-id="element-111" data-mp="zqxiqhmr8aeu">Pontenx</em>.
          </h2>
          <div className="mt-10 grid gap-6 text-base leading-relaxed text-cream-100/75 md:grid-cols-2" data-id="element-112" data-mp="vpc1kk36t9yu">
            <p data-id="element-113" data-mp="qqraba5wy0mj">
              Derrière la façade en garluche et briques rouges, on cuisine ce que le marché offre : légumes du coin,
              viandes des Landes, poisson selon l’arrivage. Une carte courte qui change avec les saisons.
            </p>
            <p data-id="element-114" data-mp="3bff18i4i55g3">
              Au comptoir, des vins de vignerons à découvrir au verre. En terrasse, des tables qui s’allongent
              quand les amis arrivent. Ici, on prend le temps.
            </p>
          </div>
        </div>

        <figure className="lg:col-span-5" data-id="element-115" data-mp="1f6zz1z43ybss">
          <img src={images.facade} alt="Façade du Bistrot Jeanot en pierre garluche et briques, volets noirs et enseigne en bois" className="aspect-[4/5] w-full rounded-sm object-cover" loading="lazy" data-id="element-116" data-mp="1f6848qic4i3k" />
          <figcaption className="mt-4 flex items-baseline justify-between text-sm text-cream-100/60" data-id="element-117" data-mp="1a7n5ywmn88hr">
            <span data-id="element-118" data-mp="wgs07t7fy7ie">La maison, à la tombée du jour</span>
            <span className="font-script text-3xl text-ember-400" data-id="element-119" data-mp="wicwpodbg0iw">depuis toujours</span>
          </figcaption>
        </figure>
      </div>
    </section>;
}